import FAQSection from '../components/FAQSection';

const FAQPage = () => <FAQSection />;

export default FAQPage;